import { useState } from 'react';
import TableFunction from '../../../components/table/TableFunction';
import CustomTh from '../../../components/table/CustomTh';
import CustomTd from '../../../components/table/CustomTd';
import { IconAvatarTable, IconClockTable, IconScheduleTable } from '../../../components/buttons/IconButtons';
import CustomChip from '../../../components/CustomChip';
import CustomTooltip from '../../../components/CustomTooltip';
import {EMPTY_VALUES, getDateFormat, getTimeFormat} from './../../../Apis/functions';
import { POSITION_MODEL } from '../../../Helpers/PositionModel';
import { SEARCH_MODEL } from '../../../components/table/Model/TableModel';
import { SimpleSearchWithId } from '../../../reduxToolkit/Search/SearchApi';
import { useDispatch} from 'react-redux';
import { ACCESS_TYPE_MATERIAL_MODEL } from './Model/Models';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AccessLogTabApp = ({ employeeId, setCriteria, option, materialId }) => {
    // Stores the ID of the table element used for rendering and DOM references.
    const [tableId, setTableId] = useState('tbl_alt_access_log');
    // Stores the ID of the search input associated with this table.
    const dispatch = useDispatch();
    const [searchResults, setSearchResults] = useState({
        content: [],
        totalElement:0
    });
    const [searchId, setSearchId] = useState('txt_alt_search_access_log');

    // The employee column is hidden when the log belongs to a single user, the name
    // would be repeated on every row.
    const showEmployee = !employeeId;
    const columnWidth = showEmployee ? 'w-25' : 'w-30';

    // Returns table header elements required by the custom TableFunction.
    const getThead = () => {
        return [
            <CustomTh key='issue_date' classes={columnWidth} tableId={tableId}>
                {t('date')}
            </CustomTh>,
            showEmployee && (
                <CustomTh key='employee' classes={columnWidth} tableId={tableId}>
                    {t('employee')}
                </CustomTh>
            ),
            <CustomTh key='guard' classes={columnWidth} tableId={tableId}>
                {t('guard')}
            </CustomTh>,
            <CustomTh key='type' classes={columnWidth} tableId={tableId}>
                {t('type')}
            </CustomTh>,
        ].filter(Boolean);
    };

    // Returns the table body rows and raw dataset.
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        const body = searchResults?.content?.map((item) => {
            const accessType = ACCESS_TYPE_MATERIAL_MODEL[item?.accessType];

            return (
                <>
                    <CustomTd tableId={tableId}>
                        <div className={'d-flex'}>
                            <IconScheduleTable
                                className={'mr-8px mb-1 icon-color-general-950 fs-14px ibl-font-w-600'}
                            />
                            <p className='fs-14px ibl-font-w-600'> {getDateFormat(item?.accessDate, false)}</p>
                        </div>
                        <div className={'d-flex'}>
                            <IconClockTable className={'mr-8px mb-1 icon-color-general-950 '}/>
                            <p className='fs-14px ibl-font-w-600'>{getTimeFormat(item?.accessDate)}</p>
                        </div>
                    </CustomTd>
                    {showEmployee &&
                        <CustomTd tableId={tableId}>
                            <CustomTooltip
                                text={item?.userFullName}
                                classes='d-flex align-items-center fs-14px text-ellipsis-1-row'
                                showIfTruncated={true}
                                icon={<IconAvatarTable className='mr-8px flex-shrink-0 icon-color-general-950' />}
                            />
                        </CustomTd>
                    }
                    <CustomTd tableId={tableId}>
                        {item?.guardFullName ?
                            <CustomTooltip
                                text={item?.guardFullName}
                                classes='d-flex align-items-center fs-14px text-ellipsis-1-row'
                                showIfTruncated={true}
                                icon={<IconAvatarTable className='mr-8px flex-shrink-0 icon-color-general-950'/>}
                            />
                            : EMPTY_VALUES.DEFAULT
                        }
                    </CustomTd>
                    <CustomTd>
                        <CustomChip
                            legend={t(accessType.trans)}
                            background={accessType.chipColor}
                            fontColor={accessType.fontColor}
                            borderColor={accessType.chipColor}
                            variant='compact'
                            icon={accessType.Icon}
                            classNameIcon={`${accessType.color} h-16px w-16px`}
                            iconPosition={POSITION_MODEL.RIGHT}
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body,
            data: searchResults?.content,
        };
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            userId:  materialId || employeeId
        });

        // Save the request body for export purposes
        setCriteria(body);
        // Dispatch the search action and handle the response
        dispatch(SimpleSearchWithId({ body })).then(
            ({
                 payload: {
                     data: { data, success}
                 }
             }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            }
        );
    };

    // Extracts table rendering and pagination utilities from TableFunction.
    const { t, thead, tbody, pagination, page, setPage, rowsPerPage, setRowsPerPage } = TableFunction({
        data: searchResults,
        labelRowsPerPage: 'access_logs_per_page',
        getTbody,
        getThead,
        fixedPagination: false,
        hasContainer: true,
        getData
    });
    return {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage };
};

export default AccessLogTabApp;
